// extracted by mini-css-extract-plugin
module.exports = {"phoneRegion":"style_phoneRegion__30-4A"};